import { createSelector } from '@reduxjs/toolkit';
import { SystemParametersListItem } from 'ducks/system-parameters-list/slices';
import { RootState } from 'store';

const systemParametersListSlice = (state: RootState) => state.system_parameters_list;

export const selectSystemParametersList = createSelector(
  [systemParametersListSlice],
  (state): SystemParametersListItem[] => state,
);
